import { route } from './router.js';
import './styles/base.css';
import './styles/shared.css';
import './styles/forensic.css';
import './styles/minimal.css';
import './styles/vintage.css';

const root = document.getElementById('app');
route(root);
